import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsFactDepartmentsGrid } from './MarketingEventsFactDepartmentsGrid';
import i18n from '../../../../i18n';
import { MarketingEventsFactDepartmentsGridPluginSettings } from './MarketingEventsFactDepartmentsGridPluginSettings';

export const MarketingEventsFactDepartmentsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEventsFactDepartments"),
        view: {
            content: MarketingEventsFactDepartmentsGridPluginSettings
                ? <MarketingEventsFactDepartmentsGrid gridId={uuidv4()} plugin={MarketingEventsFactDepartmentsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
